module.exports = __webpack_public_path__ + "ak.no2.0bc9ad42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ak.no2.jpg
// module id = kMBn
// module chunks = 0